<template>
  <div class="storage-box flex-center">
    <p>{{ subscriptionName }}</p>

    <div class="dashboard-bar progress-box">
      <p>{{ usagePercentage }}%</p>
      <div class="progress" role="progressbar" aria-label="Basic example" :aria-valuenow="usagePercentage" aria-valuemin="0" aria-valuemax="100">
        <div class="progress-bar" :class="getPercentageClass()" :style="`width: ${usagePercentage}%`"></div>
      </div>
      <!-- <router-link to="/dashboard">
        {{ usagePercentage }}% {{ $t('dashboard.imageTotalUsage') }} <span>{{ $t('dashboard.imageTotalCount', {imageTotal: imageTotal, quotaAvailable, quotaAvailable}) }}</span>
      </router-link> -->
      <button class="btn btn-outline-secondary" type="button" name="button">
        <IconArrowUp/>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.storage-box {
  flex-direction:                  column;
  gap:                             5px;
  padding:                         11px 10px;
  margin-right:                    10px;

  p {
    color:                         var(--Brand-Primary);
    text-align:                    center;
    font-size:                     var(--font-size-10);
    font-weight:                   500;
    line-height:                   normal;
    letter-spacing:                2.15px;
    text-transform:                uppercase;
    margin:                        0;
  }

  .progress-box {
    margin:                        0;
  }
}

.dashboard-bar {
  @include                              border_radius(30px);
  display:                              flex;
  flex-direction:                       row;
  justify-self:                         center;
  align-items:                          center;
  width:                                auto !important;
  height:                               28px;
  padding:                              4px 4px 4px 10px;
  gap:                                  10px;
  border:                               1.5px solid var(--Shades-30-Border);

  p {
    color:                              var(--Brand-Secondary);
    font-size:                          var(--font-size-10);
    font-weight:                        500;
    line-height:                        normal;
    letter-spacing:                     1px;
    text-transform:                     uppercase;
    margin:                             0;
  }

  .btn-outline-secondary {
    @include                            border_radius(0 30px 30px 0);
    height:                             100%;
    min-height:                         unset;
    padding:                            0 7px;
    margin:                             0;
    border:                             0;
    border-left:                        1.5px solid var(--Shades-30-Border);
    background-color:                   unset;

    :deep(svg) {
      * {
        stroke:                         var(--Brand-Primary);
      }
    }
  }
}

.progress-box {
  text-align:                           center;
  margin-bottom:                        5px;
  .progress {
    width:                              60px;
    height:                             10px;
    border:                             0.5px solid $gainsboro;
  }
  .progress-bar {
    @include                            border_radius(var(--bs-progress-border-radius));
  }
  a {
    color:                              var(--Brand-Primary, #1B294A) !important;
    font-size:                          var(--font-size-10);
    font-weight:                        500;
    text-transform:                     uppercase;
    span {
      font-weight:                      400;
      text-transform:                   lowercase;
    }
  }
}

header {
  .progress-box {
    a {
      span {
        display:                        none;
      }
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'

export default {
  name: 'MenuStorageBar',
  data: () => ({
    clinicUsage: {},
    usagePercentage: null,
    session: {
      collaborator: {},
      currentClinic: {}
    },
    imageTotal: 5000,
    quotaAvailable: 5000,
    subscriptionName: '',
  }),
  created() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let params = {
        id: this.session.currentClinic.id
      }

      NProgress.start()
      try {
        let response = await this.$dashboardService.getClinicUsage(params);
        this.clinicUsage = response.clinicUsage

        console.log('this.clinicUsage', this.clinicUsage);

        this.getPercentageValue()
        this.getClinicSubscription(this.session.currentClinic.email)
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true);
    },
    getPercentageValue() {
      this.usagePercentage = this.$dashboardService.getPercentageValue(this.clinicUsage.examTotal)
    },
    getPercentageClass() {
      return this.$dashboardService.getPercentageClass(this.usagePercentage)
    },
    async getClinicSubscription(email) {
      this.loading = true
      NProgress.start()
      
      try {
        let response = await this.$stripeService.getClinicSubscription({email: email});
        console.log('response clinic subscriber', response);
        this.subscriptionName = response.subscriptions[0]?.product_name ?? this.$i18n.t('plans.freePlan')
      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
  },
}
</script>
